const headeerSticky = (sHeader) => {
    const headers = document.querySelectorAll(sHeader);
    headers && headers.forEach(header => {
        const headrHeight = header.offsetHeight;
        const sticky = () => {
            if (window.scrollY > headrHeight + 250) {
                header.classList.add('sticky');
            }
            else {
                header.classList.remove('sticky');
            }
        };
        window.addEventListener('scroll', sticky);
    });
};
export default headeerSticky;
